module.exports = __webpack_public_path__ + "img/ico_data.c95b0c86.svg";